import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Heading, ValueInputField } = designSystem;

const ValueInputControl = ({ title, control, name, rules = {}, onChange, ...otherProps }) => (
  <div className="ws-design-fonts-dialog__control">
    <Heading type="heading-6" singleLine>
      {title}
    </Heading>
    <ValueInputField
      control={control}
      name={name}
      rules={rules}
      appearance="gray"
      size="small"
      align="left"
      onChange={onChange}
      {...otherProps}
    />
  </div>
);

ValueInputControl.propTypes = {
  title: PropTypes.node.isRequired,
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

export default ValueInputControl;
